const LoadingComponent: React.FC = () => {
  return <div className="spinner-border spinner-border-sm" role="status" />;
};

export default LoadingComponent;
